import 'es6-promise/auto'
import Vue from 'vue'
import Vuex from 'vuex'

import vSelect from 'vue-select'
import VueMeta from 'vue-meta'
import PortalVue from 'portal-vue'
import { createInertiaApp, Link } from '@inertiajs/inertia-vue'
import { InertiaProgress } from '@inertiajs/progress'
import { Inertia } from '@inertiajs/inertia'
import * as Sentry from '@sentry/vue'

import VueI18n from 'vue-i18n'
import vClickOutside from 'v-click-outside'

import store from './Store/index'
import Helpers from './Mixins/Helpers'
import http from './http/axios'
import DateFormats from './Mixins/DateFormats'
import gtmTracking from './Services/gtmTracking'
import fbqTracking from './Services/fbqTracking'
import { ENABLE_SENTRY } from './Services/logError'

require('./bootstrap')

createInertiaApp({
  resolve: (name) => import(`~/Pages/${name}`),
  setup({ el, App, props, plugin }) {
    Vue.use(plugin)
    Vue.use(vClickOutside)

    Vue.use(PortalVue)
    Vue.use(VueMeta)
    Vue.use(VueI18n)
    Vue.use(Vuex)

    const i18n = new VueI18n({
      locale: props.props.initialPage.props.locale,
      fallbackLocale: 'en',
      messages: window.translations
    })

    Inertia.on('navigate', (event) => {
      gtmTracking.trackNavigation(event.detail.page.url)
      fbqTracking.trackPageView()
    })

    Vue.mixin(DateFormats)
    Vue.mixin(Helpers)
    // eslint-disable-next-line no-undef
    Vue.mixin({ methods: { route } }) // route is defined globally, would be better to rename to $route
    InertiaProgress.init({
      color: '#5049DB'
    })

    Vue.prototype.axios = http

    Vue.component('InertiaLink', Link)
    Vue.component('VSelect', vSelect)

    if (ENABLE_SENTRY) {
      Sentry.init({
        Vue,
        dsn: process.env.MIX_SENTRY_VUE_DSN,
        tracesSampleRate: process.env.MIX_SENTRY_VUE_TRACES_SAMPLE_RATE,
        environment: process.env.MIX_APP_ENV
      })
    }

    new Vue({
      metaInfo: {
        titleTemplate: (title) => (title ? `${title}` : 'Vow Health')
      },
      i18n,
      store: new Vuex.Store(store),
      render: (h) => h(App, props)
    }).$mount(el)
  }
})
